<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="absolute inset-0 bg-black/70 z-50">
    <div class="absolute inset-x-0 top-1/3 bottom-0">
      <div class="flex max-w-4xl mx-auto p-4 top-1/3 rounded-md bg-red-50">
        <div class="flex-shrink-0">
          <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-red-800">
            Sorry, the following error occured:
          </h3>
          <div class="mt-2 text-sm text-red-700">
            <ul role="list" class="list-disc pl-5 space-y-1">
              <li id="alert-with-description-message" v-if="typeof message === 'string' && message !== ''">
                {{ message }}
              </li>
              <li id="alert-with-description-error" v-if="error !== undefined && error !== null && typeof error.message === 'string' && error.message !== ''">
                Error code: {{ error.message }}
              </li>
              <li id="alert-with-description-error" v-if="error !== undefined && error !== null && typeof error.message === 'function' && error.message() !== ''">
                Error code: {{ error.message() }}
              </li>
              <li id="alert-with-description-errorlocation" v-if="has_details()">
                Error location: {{ error.filename }} @ line {{ error.lineNumber }}
              </li>
              <li>Error details: {{ error }}</li>
            </ul>
          </div>
          <div class="mt-2">
            <button type="button"
              class="ml-3 bg-red-50 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
              @click="$emit('on_close')"
              id="component-erroralert-dismissbtn"
              >Dismiss</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XCircleIcon } from '@heroicons/vue/24/solid';

export default {
  name: 'AlertError',
  components: {
    XCircleIcon,
  },
  props: [ 'message', 'error' ],
  methods: {
    has_details: function() {
      return (this.error !== undefined && this.error !== null && this.error.filename && this.error.lineNumber );
    }
  }
}
</script>
